import { format, isValid, parseISO } from 'date-fns'

import { DATE_FULL_FORMAT_FROM_TIME } from '../../../../constants/date'
import { DRAFT_CREATE_ACTION } from '../../../Draft'
import {
  LISTING_FORM_FIELD_NAME_FLAT,
  LISTING_FORM_FIELD_NAME_PHOTOS,
} from '../../RentalPortalListing.constants'
import {
  getListingDraftFormValues,
  getListingDraftSavedAt,
} from '../../RentalPortalListing.utils'

import { RentalPortalListingDraftCreateActionSelectModalOption } from './RentalPortalListingDraftCreateActionSelectModalOption'

export function getListingDraftUnitLabel(draft) {
  return getListingDraftFormValues(draft)?.[LISTING_FORM_FIELD_NAME_FLAT]?.label
}

export function getListingDraftCoverPhoto(draft) {
  const photos =
    getListingDraftFormValues(draft)?.[LISTING_FORM_FIELD_NAME_PHOTOS]

  return photos?.find(photo => photo.is_cover) ?? photos?.[0] ?? null
}

export function getListingDraftSavedAtLabel(draft) {
  const savedAt = getListingDraftSavedAt(draft)

  const savedAtDate = savedAt ? parseISO(savedAt) : null

  return savedAtDate && isValid(savedAtDate)
    ? format(savedAtDate, DATE_FULL_FORMAT_FROM_TIME)
    : null
}

export function getListingDraftCreateActionOptions({ draft, t }) {
  return [
    {
      id: DRAFT_CREATE_ACTION.createNew,
      label: t('RentalPortal.ListingDraftCreateNewActionKey'),
    },
    {
      id: DRAFT_CREATE_ACTION.openDraft,
      label: (
        <RentalPortalListingDraftCreateActionSelectModalOption draft={draft} />
      ),
    },
  ]
}
